<template>
  <b-container>
    <b-row align-v="center">
      <b-col>
        <h1>Edit Booking</h1>
        <p class="text-muted">Ref: {{ bookingId }}</p>
      </b-col>
      <b-col class="text-right">
        <b-button variant="link" role="navigation" @click="backToBookings">
          Back to Bookings
        </b-button>
      </b-col>
    </b-row>
    <b-spinner
      v-if="loading"
      variant="light"
      style="height: 20px; width: 20px;"
      label="Submitting booking"
    ></b-spinner>
    <div v-else-if="booking">
      <b-alert
        v-if="booking.bookingStatus === 'CANCELLED'"
        class="text-center"
        variant="danger"
        show
      >
        <strong>CANCELLED</strong>
        <div>
          <span v-if="booking.paymentStatus === 'PAID'">
            An online refund can be issued via your
            <a href="https://dashboard.stripe.com/payments" target="_blank">
              Stripe Payments</a
            >.
          </span>
        </div>
      </b-alert>
      <div v-else>
        <b-alert
          v-if="booking.paymentStatus === 'PAID'"
          class="text-center"
          variant="info"
          show
        >
          <strong>PAID</strong>
        </b-alert>
        <b-alert v-else class="text-center" variant="warning" show>
          <strong>NOT PAID</strong>
          <div v-if="booking.bookingStatus !== 'CANCELLED'" class="mt-2">
            <b-button @click.prevent="showBookingPaymentModal">
              View Payment Options
            </b-button>
          </div>
        </b-alert>
        <b-button
          variant="outline-danger"
          block
          @click.prevent="confirmCancelBooking(booking)"
        >
          CANCEL BOOKING
        </b-button>
      </div>
    </div>
    <booking-form
      :booking="booking"
      edit-mode
      @cancel="backToBookings"
      @saved="onSaved"
    ></booking-form>
    <booking-payment-modal
      id="bookingPaymentModal"
      :booking="booking"
      @close="closeBookingPaymentModal"
    ></booking-payment-modal>
  </b-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import BookingForm from './BookingForm';
import BookingPaymentModal from './BookingPaymentModal';
import { goBack } from '@/mixins';

export default {
  mixins: [goBack],
  components: {
    BookingForm,
    BookingPaymentModal
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      bookingById: 'bookings/bookingById'
    }),
    bookingId() {
      return this.$route.params.id;
    },
    booking() {
      return this.bookingById(this.bookingId);
    }
  },
  methods: {
    ...mapActions({
      subscribeBookings: 'bookings/subscribeBookings',
      cancelBooking: 'bookings/cancelBooking'
    }),
    showLoadingSpinner() {
      this.loading = true;
    },
    hideLoadingSpinner() {
      this.loading = false;
    },
    showBookingPaymentModal() {
      this.$bvModal.show('bookingPaymentModal');
    },
    closeBookingPaymentModal() {
      this.$bvModal.hide('bookingPaymentModal');
    },
    async confirmCancelBooking(booking) {
      let result = await this.$swal({
        type: 'warning',
        title: 'Are you sure?',
        text: 'This booking will be permanently cancelled.',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      });

      if (!result.value) return;

      try {
        await this.cancelBooking(booking);
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e
        });
      }
    },
    onSaved() {
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Booking updated.'
      });
      this.backToBookings();
    },
    backToBookings() {
      this.goBack({ name: 'bookings/calendar' });
    }
  },
  async created() {
    if (!this.bookingId) {
      this.$router.push({ name: 'bookings' });
    }

    if (!this.booking) {
      this.showLoadingSpinner();
      await this.subscribeBookings();
      this.hideLoadingSpinner();
    }
  }
};
</script>
